import React from 'react'
// libs
import styled from 'styled-components'
// context
import { RiskRegisterContext } from 'containers/Risks/RisksRegister/layers'
// icons
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
// hooks
import { useMediaQuery } from '@mui/material'
// constants
import { SCREEN_SIZE } from 'constants/screenSize'

const CloseIcon = styled((props) => <CloseRoundedIcon {...props} htmlColor='white' />)`
  && {
    cursor: pointer;
  }
`

const CloseRiskViewButton: React.FC = () => {
  const { riskView, selectRiskView } = React.useContext(RiskRegisterContext)

  const isTablet = useMediaQuery(SCREEN_SIZE.TABLET)

  if (!riskView || !isTablet) {
    return null
  }

  const onCloseClick = () => {
    localStorage.removeItem('riskView')
    selectRiskView(null)
  }

  return <CloseIcon onClick={onCloseClick} />
}

export default CloseRiskViewButton
